module.exports = __webpack_public_path__ + "static/media/Desk.399c9a8f.jpg";